import React from 'react';
import { Box, Typography } from '@mui/material';
import DOMPurify from 'dompurify';

export const renderText = (color: string, text?: string | null) => {
  if (!text) return null;

  const looksLikeHtml = /<\/?[a-z][\s\S]*>/i.test(text);

  const baseSx = {
    marginTop: '10px',
    color: color,
    lineHeight: 1.6,

    '& p': { margin: 0, marginTop: '8px' },
    '& ul, & ol': { marginTop: '8px', marginBottom: 0, paddingLeft: '22px' },
    '& li': { marginTop: '4px' },

    '& a': { color: 'inherit', textDecoration: 'underline' },
    '& strong': { fontWeight: 700 },
    '& em': { fontStyle: 'italic' },
    '& code': {
      fontFamily: 'monospace',
      padding: '2px 6px',
      borderRadius: '8px',
    },
  } as const;

  if (looksLikeHtml) {
    const safeHtml = DOMPurify.sanitize(text, {
      USE_PROFILES: { html: true },
      ALLOWED_TAGS: ['p', 'ul', 'ol', 'li', 'br', 'strong', 'em', 'a', 'code'],
      ALLOWED_ATTR: ['href', 'target', 'rel'],
    });

    return <Box sx={baseSx} dangerouslySetInnerHTML={{ __html: safeHtml }} />;
  }

  return (
    <Typography
      variant="body2"
      sx={{
        marginTop: '10px',
        whiteSpace: 'pre-line',
        color: color,
        lineHeight: 1.6,
      }}
    >
      {text}
    </Typography>
  );
};
